import { render } from "./Footer.vue?vue&type=template&id=02052236&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=02052236&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02052236"]])

export default __exports__